import axios from "axios"
import i18n from "i18next"

const setupAPI = (props = {}) => {
  const { requestHeader = {}, requestErrorHandler = () => {}, responseErrorHandler } = props

  const axiosInstance = axios.create({
    withCredentials: true,
  })

  axiosInstance.interceptors.request.use(
    function (config) {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
        ...requestHeader,
      }
      return config
    },
    function (error) {
      if (requestErrorHandler) {
        requestErrorHandler(error)
      }
      return Promise.reject(error)
    },
  )

  axiosInstance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const skipUrl = error?.config?.url === "/tw/customer/api/auth/login"

      if (!skipUrl && responseErrorHandler) {
        responseErrorHandler(error)
      }
      return Promise.reject(error)
    },
  )

  return axiosInstance
}

export const API = setupAPI()

export default setupAPI
